/** DTR cut-off settings: form <-> payload, checks and wording (pure, no React). */

export const WEEKDAYS = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 7, label: "Sunday" },
];

export const SOURCE_LABEL = {
  OWN: { label: "Company schedule", tone: "blue" },
  INHERITED: { label: "Inherited", tone: "gray" },
  GLOBAL: { label: "Global schedule", tone: "gray" },
  DEFAULT: { label: "Default (25th / 10th)", tone: "gray" },
};

const ordinal = (n) => {
  const v = n % 100;
  if (v >= 11 && v <= 13) return `${n}th`;
  return `${n}${{ 1: "st", 2: "nd", 3: "rd" }[n % 10] || "th"}`;
};

/** "Twice a month: from the 25th and the 10th · weeks start Monday". */
export const describeRule = (r) => {
  if (!r) return "";
  if (r.description) return r.description;
  const day =
    WEEKDAYS.find((w) => w.value === Number(r.weekStartsOn))?.label || "";
  const when =
    r.frequency === "MONTHLY"
      ? `Once a month: from the ${ordinal(Number(r.startDay))}`
      : `Twice a month: from the ${ordinal(Number(r.firstStartDay))} and the ${ordinal(Number(r.secondStartDay))}`;
  return `${when} · weeks start ${day}`;
};

/** Form from the rule in force (a change usually starts from it). */
export const formFrom = (rule, tomorrow) => ({
  frequency: rule?.frequency || "SEMI_MONTHLY",
  firstStartDay: rule?.firstStartDay ?? 25,
  secondStartDay: rule?.secondStartDay ?? 10,
  startDay: rule?.startDay ?? 1,
  weekStartsOn: rule?.weekStartsOn ?? 1,
  effectiveFrom: tomorrow || "",
});

const dayOk = (v) => Number.isInteger(Number(v)) && v >= 1 && v <= 28;

/** Browser-side checks (the server validates too). */
export const formProblems = (f, tomorrow) => {
  const p = [];
  if (f.frequency === "MONTHLY") {
    if (!dayOk(Number(f.startDay))) p.push("The start day must be 1 to 28.");
  } else {
    if (!dayOk(Number(f.firstStartDay)) || !dayOk(Number(f.secondStartDay)))
      p.push("Both start days must be 1 to 28.");
    else if (Number(f.firstStartDay) === Number(f.secondStartDay))
      p.push("The two start days must be different.");
  }
  if (!f.effectiveFrom) p.push("Pick the date the new schedule starts.");
  else if (tomorrow && f.effectiveFrom < tomorrow)
    p.push("The new schedule must start after today.");
  return p;
};

export const toPayload = (f) => ({
  frequency: f.frequency,
  firstStartDay: Number(f.firstStartDay),
  secondStartDay: Number(f.secondStartDay),
  startDay: Number(f.startDay),
  weekStartsOn: Number(f.weekStartsOn),
  effectiveFrom: f.effectiveFrom,
});
